import { Component, OnInit, signal, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';
import { Router } from '@angular/router';

import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { SpacesService } from '@generated/services/spaces.service';
import { NotificationService } from '@core/services/notification.service';
import { SpaceService } from '@core/services/space.service';
import { CreateSpaceRequest, CreateSpaceResult } from '@generated/models';
import { AssistantSurfaceDirective } from '@shared/directives/assistant-surface.directive';
import { AssistantEditableDirective } from '@shared/directives/assistant-editable.directive';
import { AssistantActionDirective } from '@shared/directives/assistant-action.directive';

@Component({
  selector: 'app-space-create',
  standalone: true,
  imports: [
    AssistantSurfaceDirective,
    AssistantEditableDirective,
    AssistantActionDirective,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    TextareaModule
],
  templateUrl: './space-create.html',
  styleUrl: './space-create.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpaceCreateComponent implements OnInit {
  private fb = inject(FormBuilder);
  private spacesService = inject(SpacesService);
  private notificationService = inject(NotificationService);
  private spaceService = inject(SpaceService);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);

  createForm!: FormGroup;
  loading = signal(false);
  maxNameLength = 50;
  maxDescriptionLength = 200;

  ngOnInit() {
    this.createForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(this.maxNameLength)]],
      description: ['', [Validators.maxLength(this.maxDescriptionLength)]]
    });
  }

  get nameControl() {
    return this.createForm.get('name');
  }

  get descriptionControl() {
    return this.createForm.get('description');
  }

  get nameLength(): number {
    return this.nameControl?.value?.length || 0;
  }

  get descriptionLength(): number {
    return this.descriptionControl?.value?.length || 0;
  }

  goBack() {
    this.router.navigate(['/spaces']);
  }

  onSubmit() {
    if (this.createForm.valid && !this.loading()) {
      this.loading.set(true);
      
      const spaceData: CreateSpaceRequest = {
        name: this.nameControl?.value,
        description: this.descriptionControl?.value || null
      };

      this.spacesService.apiSpacesPost({ body: spaceData }).subscribe({
        next: (space: CreateSpaceResult) => {
          console.log('Space created:', space);
          this.notificationService.showSuccess('Workspace created successfully');
          this.spaceService.loadSpaces();
          this.router.navigate(['/spaces', space.id]);
        },
        error: (error: any) => {
          console.error('Error creating space:', error);
          this.loading.set(false);
        }
      });
    }
  }
}